import {ListItem as GWCListItem, ListItemBase as GWCListItemBase, ListItemProps as GWCListItemProps} from '@gwc/core'
import clsx from 'clsx'
import {forwardRef} from 'react'

import {cssTheme} from '../theme'
import {classes, setOffset} from './ListItem.classes'

type DividerOffsetMixin = {
  dividerOffset?: keyof typeof cssTheme['spacingUnits']
}

type LinkComponentProps = {
  newTab?: boolean
}

export type ListItemProps<C extends Function | keyof JSX.IntrinsicElements> = GWCListItemProps<C> & DividerOffsetMixin & LinkComponentProps

export const ListItem = forwardRef(function ListItem<C extends Function | keyof JSX.IntrinsicElements>(
  {dividerOffset, className, style, ...props}: ListItemProps<C>,
  ref,
) {
  const offsetStyle = !!dividerOffset ? setOffset(cssTheme.spacingUnits[dividerOffset]) : {}

  return (
    <GWCListItem
      {...props}
      ref={ref}
      className={clsx(className, classes.dividerOffset)}
      style={{...style, ...offsetStyle}}
    />
  )
})

type GWCListItemBaseProps<C extends Function | keyof JSX.IntrinsicElements> = React.ComponentProps<GWCListItemBase<C>>

export type ListItemBaseProps<C extends Function | keyof JSX.IntrinsicElements> = GWCListItemBaseProps<C> &
  DividerOffsetMixin

export function ListItemBase<C extends Function | keyof JSX.IntrinsicElements>({
  dividerOffset,
  className,
  style,
  ...props
}: ListItemBaseProps<C>) {
  const offsetStyle = !!dividerOffset ? setOffset(cssTheme.spacingUnits[dividerOffset]) : {}
  return (
    <GWCListItemBase {...props} className={clsx(className, classes.dividerOffset)} style={{...style, ...offsetStyle}} />
  )
}
